(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3RegionDropdown', {
            templateUrl: 'app/shared/region-dropdown/region-dropdown.component.html',
            controller: RegionDropdownComponent,
            require: {
                ngModel: 'ngModel'
            },
            bindings: {
                name: '@',
                notifyCountryChanged: '&countryChange'
            }
        });

    var isDefined = angular.isDefined;

    RegionDropdownComponent.$inject = ['$element', '$scope', 'regions', 'countryCodes', 'selectProvinceCaption', 'selectStateCaption', '$timeout'];
    function RegionDropdownComponent($element, $scope, regions, countryCodes, selectProvinceCaption, selectStateCaption, $timeout) {
        // Variables
        var ctrl = this, region, country;

        // Properties
        ctrl.regions = regions;
        ctrl.region = null;
        ctrl.country = null;
        Object.defineProperty(ctrl, 'emptyText', { get: getEmptyText })
        
        // Methods
        ctrl.$onInit = $timeout.bind(null, init, 0, true);
        ctrl.regionChange = regionChange;
        ctrl.countryChange = countryChange;

        //////////////////////

        function init() {
            ctrl.region = regions.find(find);
            ctrl.country = ctrl.region && ctrl.region.country || countryCodes.CA;
            ctrl.notifyCountryChanged({ $value: ctrl.country });

            $element.on('focusout', focusout);
            $scope.$on('$destroy', destroy);

            function find(region) {
                return region.region === ctrl.ngModel.$modelValue;
            }
        }

        function destroy() {
            $element.off('focusout', focusout);
        }


        function regionChange() {
            var value = ctrl.region && ctrl.region.region || null;
            ctrl.ngModel.$setViewValue(value);
        }

        function countryChange() {
            ctrl.region = null;
            regionChange();
            ctrl.notifyCountryChanged({ $value: ctrl.country });
        }

        function getEmptyText() {
            return ctrl.country == countryCodes.US ? selectStateCaption : selectProvinceCaption;
        }

        function focusout() {
            if (!$element[0].contains(document.activeElement)) 
                ctrl.ngModel.$$element.triggerHandler('blur');
        }
    }
})();